/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Cross-dimensional aggregation row: one entry per unique (user, server, hook_source, tool) combination
 */
export type HooksBreakdownRow = {
  /**
   * Total events for this combination
   */
  eventCount: number;
  /**
   * Number of failures for this combination
   */
  failureCount: number;
  /**
   * Hook source (e.g. claude-desktop, cursor)
   */
  hookSource: string;
  /**
   * Server name ('local' for non-MCP tools)
   */
  serverName: string;
  /**
   * Tool name
   */
  toolName: string;
  /**
   * User email address
   */
  userEmail: string;
};

/** @internal */
export const HooksBreakdownRow$inboundSchema: z.ZodMiniType<
  HooksBreakdownRow,
  unknown
> = z.pipe(
  z.object({
    event_count: z.int(),
    failure_count: z.int(),
    hook_source: z.string(),
    server_name: z.string(),
    tool_name: z.string(),
    user_email: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "event_count": "eventCount",
      "failure_count": "failureCount",
      "hook_source": "hookSource",
      "server_name": "serverName",
      "tool_name": "toolName",
      "user_email": "userEmail",
    });
  }),
);

export function hooksBreakdownRowFromJSON(
  jsonString: string,
): SafeParseResult<HooksBreakdownRow, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => HooksBreakdownRow$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'HooksBreakdownRow' from JSON`,
  );
}
